module.exports = __webpack_public_path__ + "static/media/kid1.5f4a56ff.jpg";